import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBetQuaddie = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.375,
	height: 22.594,
	viewBox: "0 0 18.375 22.594",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Quaddie",
		children: [
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7566",
				d: "M17.625,21.844V2.157A1.407,1.407,0,0,0,16.219.75H2.156A1.407,1.407,0,0,0,.75,2.157V21.844l4.812-2.813,3.625,2.813,3.626-2.813Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7567",
				d: "M6.75,12.138a.352.352,0,0,1-.075-.7.314.314,0,0,1,.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7568",
				d: "M6.75,12.138a.352.352,0,0,0,.075-.7.314.314,0,0,0-.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7569",
				d: "M6.75,6.919a.352.352,0,0,1-.075-.7.314.314,0,0,1,.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7570",
				d: "M6.75,6.919a.352.352,0,0,0,.075-.7.314.314,0,0,0-.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7571",
				d: "M11.625,12.138a.352.352,0,0,1-.075-.7.314.314,0,0,1,.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7572",
				d: "M11.625,12.138a.352.352,0,0,0,.075-.7.314.314,0,0,0-.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7573",
				d: "M11.625,6.919a.352.352,0,0,1-.075-.7.314.314,0,0,1,.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7574",
				d: "M11.625,6.919a.352.352,0,0,0,.075-.7.314.314,0,0,0-.075,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			})
		]
	})
});
export { SvgBetQuaddie as ReactComponent };
